import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
import giftApis from "src/api/gifts"
import CommonContainer from "src/components/CommonContainer"
import { NA } from "src/constants/common"
import { TEM_ACCUMULATION_HISTORY } from "src/constants/queryKeys"
import { useAuthContext } from "src/hooks"
import { theme } from "src/providers/ThemeProvider"
import { GreenChecked, Text } from "src/shared"
import { formatDate } from "src/utils/formatDate"

const TemAccumulation = () => {
  const { profile } = useAuthContext()
  const { data: temTransactions } = useQuery({
    queryKey: [TEM_ACCUMULATION_HISTORY],
    queryFn: () =>
      giftApis.getGiftAccumulationHistory({
        customerPhone: profile?.Mobile || "",
        pageIndex: 0,
        pageSize: 100,
        transactionType: 1,
      }),
    enabled: !!profile?.Mobile,
  })

  const sortTemTransactions = useMemo(() => {
    if (!temTransactions || !temTransactions.length) return []
    return temTransactions.sort((a, b) =>
      new Date(a?.CreatedDate) > new Date(b?.CreatedDate) ? -1 : 0
    )
  }, [temTransactions])

  return (
    <CommonContainer
      bannerProps={{
        alt: "lich_su_tich_tem_banner",
        src: "/assets/images/lich_su_tich_tem_banner.png",
      }}
    >
      <TableContainer
        sx={() => ({
          p: "0px 30px",
          boxShadow: "none",
          maxHeight: 500,
          overflowX: "hidden",
          [theme.breakpoints.down(500)]: {
            padding: theme.spacing(0, 1.5),
          },
        })}
        component={Paper}
      >
        <Table
          sx={theme => ({
            borderCollapse: "unset",
            borderSpacing: 0,
            borderRadius: theme.spacing(2),
            border: `solid 1px ${theme.palette.grey[200]}`,
            borderTopStyle: "none",
          })}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow
              sx={theme => ({
                "& th": {
                  bgcolor: theme.palette.info.main,
                  color: theme.palette.common.white,
                  padding: "10px",
                  fontSize: 16,
                  fontFamily: "Roboto Slab",
                  fontWeight: 400,
                },
              })}
            >
              <TableCell
                sx={theme => ({
                  width: "20%",
                  borderTopLeftRadius: theme.spacing(2),
                })}
                align="center"
              >
                Mã bill
              </TableCell>
              <TableCell
                sx={theme => ({
                  width: "60%",
                  borderRight: `solid 1px ${theme.palette.common.white}`,
                  borderLeft: `solid 1px ${theme.palette.common.white}`,
                })}
                align="center"
              >
                Cửa hàng
              </TableCell>
              <TableCell
                sx={theme => ({
                  width: "20%",
                  borderTopRightRadius: theme.spacing(2),
                })}
                align="center"
              >
                Số lượng
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortTemTransactions.map(row => (
              <TableRow
                key={row.Id}
                sx={theme => ({
                  "&:last-child td, &:last-child th": { border: 0 },
                  "& td": { p: theme.spacing(1, 2) },
                  [theme.breakpoints.down(500)]: {
                    "& td": {
                      p: 1,
                    },
                  },
                })}
              >
                <TableCell align="center" scope="row">
                  <Text fontSize={13} fontWeight={500}>
                    {row.TransactionId}
                  </Text>
                  <Text
                    fontSize={13}
                    sx={theme => ({
                      color: theme.palette.grey[400],
                    })}
                  >
                    {formatDate(row.CreatedDate, "YYYY/MM/DD")}
                  </Text>
                </TableCell>
                <TableCell
                  sx={theme => ({
                    borderRight: `solid 1px ${theme.palette.grey[200]} !important`,
                    borderLeft: `solid 1px ${theme.palette.grey[200]} !important`,
                  })}
                  scope="row"
                >
                  <Text
                    fontSize={16}
                    sx={theme => ({
                      color: theme.palette.grey[400],
                    })}
                  >
                    {row.Address || NA}
                  </Text>
                </TableCell>
                <TableCell align="center">
                  <GreenChecked />
                  <Text
                    fontSize={16}
                    sx={theme => ({
                      color: theme.palette.grey[400],
                    })}
                  >
                    {row.TemQuantity} TEM
                  </Text>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CommonContainer>
  )
}

export default TemAccumulation
